import { useId } from "react";
import clsx from "clsx"

import { Checkbox } from "@/stories/components/Form/Checkbox/Checkbox";
import type { IconType } from "@/stories/atoms/Icon/Icon";
import { TypeBien } from "@/stories/organisms/Search/Filters/TypeBien/TypeBien";
import { Dpe } from "@/stories/organisms/Search/Filters/Dpe/Dpe";
import { Toggle } from "@/stories/components/Form/Toggle/Toggle";
import { FormItem } from "@/stories/components/Form/FormItem/FormItem";
import { type InputProps } from "../Input/Input";

import labelStyles from "@/stories/components/Form/FormItem/label.module.css";
import styles from './list.module.css'

// Type pour les items de refinement
export type RefinementItem = {
  label: string;
  value: string;
  isRefined: boolean;
  icon?: IconType
};

export type ListProps = {
  values?: string[],
  setValues: (values: string[]) => void,
  className?: string,
  list: {
    label: string
    icon?: IconType
  }[],
  hideOptionnal?: boolean,
  item?: 'TypeBien' | 'Dpe' | 'Toggle'
  scrollable?: boolean,
} & Omit<InputProps, 'id' | 'list' | 'ref'>

const mapping = {
  TypeBien,
  Dpe,
  Toggle
}

export const List = ({values, setValues, name, label, list, className, variant, inline, scrollable, item, ...props}: ListProps) => {
  const id = useId()

  const renderCheckbox = ({label, isRefined, value, icon, ...itemProps}: RefinementItem) => {
    if (item) {
      const Component = mapping[item]

      return (
        <Component
          key={label}
          name={name}
          value={value}
          variant={variant}
          id={label + id}
          checked={isRefined}
          onChange={() => setValues(values && values.includes(value) ? [...values.filter(t => t !== value)] : [...(values ? values: []), value])}
          label={label}
          icon={icon}
          className={styles.field}
          {...itemProps}/>
      )
    }

    return (
      <Checkbox
        key={label}
        name={name}
        id={label + id}
        checked={isRefined}
        variant={variant}
        onChange={() => setValues(values && values.includes(value) ? [...values.filter(t => t !== value)] : [...(values ? values: []), value])}
        label={`${label}`}
        className={styles.field}
        {...itemProps}/>
    )
  }

  return (
    <FormItem className={className} {...props}>
      {label && <span className={clsx(labelStyles.label, props.hideLabel && 'sr-only')}>{label}{!props.required && !props.hideOptionnal && <span className={labelStyles.optionnal}>optionnel</span>}</span>}
      <div className={clsx(styles.list, inline && styles.inline, scrollable && styles.scrollable)}>
        {list.map((item) => {

          return renderCheckbox({label: item.label, value: item.label, isRefined: values ? values.includes(item.label) : false, icon: item.icon})
        })}
      </div>
    </FormItem>
  )
}